/**
 * 코메 공유 상수 — 서버/클라이언트/관리자 공통.
 */

export const API_VERSION = 'v1';
export const API_BASE = `/api/${API_VERSION}`;

/** 개발용 관리자 코드 (운영 전 보안 강화 예정 — SPEC §9) */
export const DEFAULT_ADMIN_CODE = '426846';

/** JWT */
export const ACCESS_TOKEN_TTL_SEC = 60 * 60 * 12; // 12h
export const REFRESH_TOKEN_TTL_SEC = 60 * 60 * 24 * 30; // 30d
export const ADMIN_TOKEN_TTL_SEC = 60 * 60 * 4; // 4h

/** OTP */
export const OTP_TTL_SEC = 60 * 5;
export const OTP_MAX_ATTEMPTS = 5;
export const OTP_LENGTH = 6;

/** 메시지 */
export const MESSAGE_PAGE_SIZE = 30;
export const MAX_MESSAGE_LENGTH = 5000;
export const MAX_GROUP_MEMBERS = 500;

/** 파일 업로드 */
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const MAX_IMAGE_SIZE = 20 * 1024 * 1024; // 20MB
export const ALLOWED_IMAGE_MIME = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

/** AI */
export const AI_USER_ID = 'ai-claude'; // 가상 사용자 id (AI 비서, 내부 식별자)
export const AI_USER_NAME = 'AI 비서';
/** AI 엔진: Google Gemini (env.GEMINI_MODEL 로 런타임 교체 가능) */
export const GEMINI_MODEL = 'gemini-2.5-flash';
export const GEMINI_MODEL_FAST = 'gemini-2.5-flash';
export const AI_MENTION = '@AI';

/** 일일 요약 */
export const SUMMARY_CRON = '0 18 * * *'; // 매일 18:00 UTC (KST 03:00) — 운영 시 조정
export const SUMMARY_LOOKBACK_HOURS = 24;

/** 연동 제공자 */
export const INTEGRATION_PROVIDERS = ['gmail', 'microsoft', 'claude', 'image', 'mcp'] as const;

/** WebSocket */
export const WS_PING_INTERVAL_MS = 25_000;
export const WS_RECONNECT_BASE_MS = 1_000;
export const WS_RECONNECT_MAX_MS = 30_000;
